module.exports = __webpack_public_path__ + "img/s1-3.76084f88.jpg";